import store from "../../../../store";
import { has, have } from "../../../../utils/menu-context";
import { isOperationAndSubStanceTypeMain } from "./request.section";
import { commonInputPropField } from "../../inform/request/request.condition";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refHazDiscussTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
                || (record.refHazDiscussTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitReceive: ({ record }) => {
            let result = false;
            if (
                (record.createBy === store.state.resource.auth.info.user?.username ||
                    (record.createBy === "anonymousUser" &&
                        record.refHazDiscussTemp?.refUser?.username === store.state.resource.auth.info.user?.username)) &&
                !record.isOfficerCreate
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (record.isOfficerCreate) {
                if (["draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReport: ({ record }) => {
            return !["draft"].includes(record.refStatus?.key);
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refDepartment.nameEn",
                    "lastStatus.waitReceive.0.statusDatetime",
                    "lastStatus.draft.0.statusDatetime",
                    "lastStatus.waitApprove.0.statusDatetime",
                    "refHazDiscussTemp.refUserCompany.companyNameEn",
                    "refHazDiscussTemp.refUser.fullNameEn",
                    "refHazDiscussTemp.refUserCompany.addresses.0.addrTh",
                    "refHazDiscussTemp.refUser.addresses.0.addrTh"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.refUserCompany.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.refUser.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refRequestType"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refDocGenType", "requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.approveCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazDiscssTemp.refUserCompany", "refDepartment"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.refOperation"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                let enabled = undefined;
                if (![undefined, "draft"].includes(initialModel.refStatus?.key)) {
                    enabled = false;
                }
                if (["2", "3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.refUser"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazDiscuss"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2", "3", "4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.refUserCompany"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refHazDiscussTemp.refMainOperation",
                    "refHazDiscussTemp.refSubOperation",
                    "refHazDiscussTemp.refMainObjective",
                    //"refHazDiscussTemp.refSubObjective",
                    "refHazDiscussTemp.refManufactureCountry",
                    "refHazDiscussTemp.refDiscussTopic",
                    "refHazDiscussTemp.tradeNameTh",
                    "refHazDiscussTemp.tradeNameEn",
                    "refHazDiscussTemp.refSubStanceType",
                    "refHazDiscussTemp.manufacturer",
                    "refHazDiscussTemp.customsCoordinates",
                    "refHazDiscussTemp.isSolid",
                    "refHazDiscussTemp.isLiquid",
                    "refHazDiscussTemp.solid",
                    "refHazDiscussTemp.liquid",
                    "refHazDiscussTemp.refCountry",
                    "refHazDiscussTemp.refSubStanceTypeMain",
                    "refHazDiscussTemp.isTechnicalGrade",
                    "refHazDiscussTemp.refToUse",
                    "refHazDiscussTemp.refLd50",
                    "refHazDiscussTemp.ld50Operator",
                    "refHazDiscussTemp.ld50Value"
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
            checkboxField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refHazDiscussTemp.refSubObjective",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refHazDiscussTemp?.refMainObjective?.key === "3";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
            checkboxField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.otherToUse"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refHazDiscussTemp?.refToUse?.key === "5";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.otherSubObjective"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refHazDiscussTemp?.refSubObjective?.key === "3";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.otherDiscussTopic"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refHazDiscussTemp?.refDiscussTopic?.key === "2"; 
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazDiscussTemp.mainSubStances") &&
                      (field?.key?.endsWith("microAnalysisQty1") ||
                        field?.key?.endsWith("microAnalysisQty2") ||
                        field?.key?.endsWith("microAnalysisQty3") ||
                        field?.key?.endsWith("refMicroUnit"))
                );
            },
            visibleField: ({ modelRef, field }) => {
                return isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" })
                    || (isOperationAndSubStanceTypeMain({ modelRef, operation: "2", subStanceTypeMain: "micro" }) && modelRef.refHazDiscussTemp.mainSubStances[`${field?.key?.split('.')[2]}`]?.refSubStance?.refType?.key !== "media")
                    || isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })
                    || isOperationAndSubStanceTypeMain({ modelRef, operation: "5", subStanceTypeMain: "micro" })
                ;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        },
        {
            check: ({ field }) => {
                return (field?.key?.startsWith("refHazDiscussTemp.mainSubStances") && field?.key?.endsWith("otherSubStance"));
            },
            visibleField: ({ modelRef, field }) => {
                const refSubStance = modelRef.refHazDiscussTemp.mainSubStances[`${field?.key?.split('.')[2]}`]?.refSubStance;
                return refSubStance && !refSubStance.refType
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazDiscussTemp.mainSubStances") && (field?.key?.endsWith("refSubStance") || field?.key?.endsWith("intense"))
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazDiscussTemp.mainSubStances") && (field?.key?.endsWith("labelPictogram") || field?.key?.endsWith("pictograms") || field?.key?.endsWith("refPictogram"))
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
            visibleField: ({ modelRef, field }) => {
                return modelRef.refHazDiscussTemp.mainSubStances[`${field?.key?.split('.')[2]}`]?.refSubStance?.refType?.key != "media"
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refHazDiscussTemp.isOtherResult",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refHazDiscussTemp?.refDiscussTopic?.key === "2" && store.state.resource.auth.info?.user?.refDepartment;
            },
        },
        {
            check: ({ field }) => {
                return ["refHazDiscussTemp.otherResult"].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                const { menuContext } = props;
                let enable = false;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    enable = modelRef.refHazDiscussTemp?.isOtherResult === true;
                } else if (store.state.resource.auth.info?.user?.refDepartment) {
                    enable = modelRef.refHazDiscussTemp?.isOtherResult === true;
                }
                return enable;
            },
        },
        {
            check: ({ field }) => {
                return ["labelPictogram"].includes(field?.key);
            },
            visibleField: ({ modelRef, field }) => {
                return modelRef.refHazDiscussTemp.mainSubStances[`${field?.key?.split('.')[2]}`]?.refSubStance?.refType?.key != "media"
            },
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazDiscussTemp.aquatics") &&
                    (field?.key?.endsWith("refAquaticType") ||
                        field?.key?.endsWith("refSubAquaticType") ||
                        field?.key?.endsWith("qty") ||
                        field?.key?.endsWith("duration") ||
                        field?.key?.endsWith("refDurationUnit"))
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazDiscussTemp.useRates") && (field?.key?.endsWith("useRate") || field?.key?.endsWith("method"));
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazDiscussTemp.attachments") &&
                    (field?.key?.endsWith("documentName") ||
                        field?.key?.endsWith("attribute.documentNo") ||
                        field?.key?.endsWith("attribute.documentDate") ||
                        field?.key?.endsWith("attribute.documentExpiredDate") ||
                        field?.key?.endsWith("size"))
                );
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    return { ...common, disabled: true };
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forReceiveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ componentKey }) => {
                return [
                    "HazDiscussMainSubStanceList",
                    "HazDiscussAquaticList",
                    "UseRateList"
                ].includes(componentKey);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    canCreate = false;
                    canDelete = false;
                }
                return { canCreate, canDelete };
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazDiscussTemp.mainSubStances") && field?.key?.endsWith("casNo")                
            },
            visibleField: ({ modelRef, field }) => {
                return modelRef.refHazDiscussTemp.mainSubStances[`${field?.key?.split('.')[2]}`]?.refSubStance?.refType?.key != "media" &&
                modelRef.refHazDiscussTemp.mainSubStances[`${field?.key?.split('.')[2]}`]?.refSubStance?.refType != null;
            },
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazDiscussTemp.mainSubStances") && field?.key?.endsWith("ld50ValueLabel") ||
                    field?.key?.startsWith("refHazDiscussTemp.mainSubStances") && field?.key?.endsWith("refLd50") ||
                    field?.key?.startsWith("refHazDiscussTemp.mainSubStances") && field?.key?.endsWith("ld50Operator") ||
                    field?.key?.startsWith("refHazDiscussTemp.mainSubStances") && field?.key?.endsWith("ld50Value")                 
                )
            },
            visibleField: ({ modelRef, field }) => {
                return modelRef.refHazDiscussTemp.mainSubStances[`${field?.key?.split('.')[2]}`]?.refSubStance?.refType?.key != "media" 
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
        }
    ];
};
